import { JobStatus } from "@models/job";

export const STATUS_COLOR: Readonly<Record<JobStatus, string>> = {
  AwaitingUpload: "gray",
  Parsing: "blue",
  Running: "blue",
  Completed: "teal",
  CompletedWithErrors: "orange",
  Failed: "red",
};

export const TERMINAL_STATUSES: ReadonlySet<JobStatus> = new Set<JobStatus>([
  JobStatus.Completed,
  JobStatus.CompletedWithErrors,
  JobStatus.Failed,
]);

/** Returns true when the job is in a non-terminal (in-process) state. */
export const isProcessingStatus = (status: JobStatus): boolean =>
  !TERMINAL_STATUSES.has(status);

export const parseServiceId = (
  raw: string | undefined,
): { kind: string; pluginId: string } | null => {
  if (!raw) return null;
  const decoded = decodeURIComponent(raw);
  const [kind, pluginId] = decoded.split("#");
  if (!kind || !pluginId) return null;
  return { kind, pluginId };
};

/** The first segment of a job uuid, which is what the list column shows. */
export const shortJobId = (jobId: string): string => jobId.split("-")[0];

/**
 * Backend error codes whose raw message is too vague to be actionable, mapped
 * to the localized, guidance-rich override under
 * `mappingServicePage.jobErrors`. Every other code falls back to the
 * backend-supplied message (which the parser path already makes specific).
 */
export const JOB_ERROR_I18N_KEY: Readonly<Record<string, string>> = {
  all_rows_failed: "allRowsFailed",
  invalid_file_format: "invalidFileFormat",
  parser_unexpected_error: "unexpected",
  trigger_dispatch_failed: "unexpected",
};

export const formatTimestamp = (iso: string): string => {
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return iso;
  }
};
